import { switchTheme } from "utils/functions";
import { AppConstants } from "./constants";
import { TenantType } from "types/generic/tenant";

export const updateLanguage = (language: string) => {
    return {
        type: AppConstants.UPDATE_LANGUAGE,
        payload: language,
    };
};

export const updateTheme = (theme: "light" | "dark" | "mm") => {
    document.body.className = "";
    document.body.classList.add(theme);
    switchTheme(theme);
    return {
        type: AppConstants.UPDATE_THEME,
        payload: theme,
    };
};

export const updateIsOpenPreferencesModal = (open: boolean) => {
    return {
        type: AppConstants.IS_OPEN_PREFERENCES_MODAL,
        payload: open,
    };
};


export const updateTenant = (tenant: TenantType) => {
    return {
        type: AppConstants.UPDATE_TENANT,
        payload: tenant,
    };
};
